export class Indicadores {

    public idCompania: string;
    public idUsuario: string;
    public nombreUsuario: string;
    public idVehiculo: string;
    public idPunto: string;
    public nombrePunto: string;
    public resultado: string;
    public fecha:Date;
    public estado:string;
    public numeroDocumento:string;
    public tipoVehiculo:string;
}